export const thLang = {
  welcomeText: 'ยินดีต้อนรับสู่ Employee Portal\nกรุงไทย-แอกซ่า ประกันชีวิต ',
  loginText: 'เข้าสู่ระบบ',
  privacyPolicy: 'นโยบายความเป็นส่วนตัว',
  and: 'และ',
  tAndC: 'ข้อกำหนดและเงื่อนไข',
  otpDesc: 'กรุณากรอก หมายเลขประจำตัวประชาชนของผู้ใช้งาน\nเพื่อรับรหัส OTP ผ่านทาง SMS',
  idNumberLabel: 'หมายเลขประจำตัวประชาชน / หมายเลขหนังสือเดินทาง',
  errorNationalIdRequired: 'จำเป็นต้องมีหมายเลขประจำตัวประชาชน',
  'Invalid ID number': 'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  mobileInvalid: 'หมายเลขโทรศัพท์ไม่ถูกต้อง คุณต้องป้อนหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
  selectPhoneTitle: 'กรุณาเลือกหมายเลขโทรศัพท์\nเพื่อรับรหัส OTP',
  selectPhoneDesc:
    'หากไม่พบหมายเลขโทรศัพท์ หรือ มีการเปลี่ยนแปลงเมื่อไม่นานมานี้ หรือ ไม่สามารถรับรหัส OTP ได้ กรุณาติดต่อศูนย์ลูกค้าสัมพันธ์',
  phoneLabel: 'หมายเลขโทรศัพท์',
  sendOtpButton: 'ส่งรหัส OTP',
  verifyTitle: 'ยืนยันตัวตนด้วยรหัส OTP',
  verifyDesc: 'ระบบได้ทำการส่งรหัส OTP ผ่าน SMS ไปยังหมายเลข +66XXXXX (จาก KTAXA)',
  otpLabel: 'OTP',
  receiveSms: 'ไม่ได้รับ SMS? ',
  sendAgainIn: 'ส่งอีกครั้งใน',
  min: 'นาที',
  sendAgainButton: 'ส่งอีกครั้ง',
  nextButton: 'ถัดไป',
  confirmButton: 'ยืนยัน',
  cancelButton: 'ยกเลิก',
  changeMobilePhoneDesc:
    'หากท่านมีการเปลี่ยนแปลงหมายเลขโทรศัพท์ หรือ ไม่สามารถรับรหัส OTP\nได้ กรุณาติดต่อศูนย์ลูกค้าสัมพันธ์',
  errorOtpInvalidDigit: 'หมายเลข OTP ต้องมีความยาว 6 หลักเท่านั้น และมีเฉพาะตัวเลขเท่านั้น',
  errorOtpRequired: 'ต้องระบุหมายเลข OTP',
  otpExpiredTitle: 'รหัส OTP หมดอายุแล้ว',
  otpExpiredDesc: 'รหัส OTP ที่ระบุหมดอายุการใช้งานแล้ว\nท่านสามารถขอรหัสได้ โดยกด “ส่งรหัส OTP”',
  cannotSendOtpTitle: 'ระบบไม่สามารถส่งรหัส OTP ได้',
  cannotSendOtpDesc:
    'ขออภัย ไม่สามารถส่งรหัส OTP ได้ ในขณะนี้\nกรุณารอสักสักครู่ แล้วลองส่งรหัส OTP ใหม่อีกครั้ง',
  okButton: 'ตกลง',
  dataNotFoundTitle: 'ไม่พบข้อมูล',
  dataNotFoundDesc: 'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  textAssistanceText: 'เพื่อรับความช่วยเหลือ',
  otpInvalidText: 'รหัส OTP ไม่ถูกต้อง กรุณาลองอีกครั้ง',
  mobileRequired: 'ต้องระบุหมายเลขโทรศัพท์',
  userNotFound: 'ไม่พบผู้ใช่งาน',
  'not found data': 'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  suggestInvalidNationalId:
    'หากท่านพบปัญหาไม่สามารถส่งคำขอเพื่อรับรหัส OTP ได้\nกรุณาติดต่อศูนย์ลูกค้าสัมพันธ์',
  suggestInvalidMobilePhone:
    'หากท่านมีการเปลี่ยนแปลงหมายเลขโทรศัพท์ หรือ ไม่สามารถรับรหัส\nOTP ได้ กรุณาติดต่อศูนย์ลูกค้าสัมพันธ์',
  "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.":
    'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  'Wrong phone number or verification code.': 'รหัส OTP ไม่ถูกต้อง กรุณาลองอีกครั้ง',
  "You've reached the maximum number of attempts. Please try to login again.":
    'รหัส OTP ที่ระบุหมดอายุการใช้งานแล้ว\nท่านสามารถขอรหัสได้ โดยกด “ส่งรหัส OTP”',
  placeholderNIDPassport: 'หมายเลขบัตรประชาชน หรือ หนังสือเดินทาง',
  'The specified new phone_number already exists':
    'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  'get employee profile success': 'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  '403 Forbidden': 'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  'You cannot consume this service': 'ขออภัย ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
  home: {
    protectionServices: 'บริการด้านความคุ้มครอง',
    myPolicies: 'กรมธรรม์',
    subMyPolicies: 'ของฉัน',
    myInsuranceCards: 'บัตรประกัน',
    subMyInsuranceCards: 'ของฉัน',
    claim: 'ประวัติการเรียก',
    subClaim: 'ร้องสินไหม',
    downloadDocuments: 'ดาวน์โหลด',
    subDownloadDocuments: 'เอกสาร',
    myPoliciesList: 'รายการกรมธรรม์ของฉัน',
    policyCoverage: 'กรมธรรม์และความคุ้มครองที่ยังมีผลบังคับ',
    hospitalNetwork: 'สถานพยาบาล',
    subHospitalNetwork: 'ในเครือข่าย',
    history: 'ประวัติย้อนหลัง 1 ปี',
    allPolicyYear: 'กรมธรรม์ทั้งหมดที่ไม่มีผลบังคับ',
    selectPolicyYear: 'เลือกจากปีกรมธรรม์',
    active: 'มีผลบังคับ',
    inactive: 'ไม่มีผลบังคับ',
    moreDetails: 'รายละเอียดเพิ่มเติม',
  },

  policy: {
    servicePolicy: 'บริการจากกรมธรรม์นี้',
    basicPlan: 'ผลประโยชน์ความคุ้มครอง: สัญญาหลัก',
    additionalPlan: 'ผลประโยชน์ความคุ้มครอง: สัญญาเพิ่มเติม',
    familyPlan: 'ความคุ้มครองสำหรับสมาชิกในครอบครัว',
    myInsuranceCards: 'บัตรประกันของฉัน',
    balanceOpd: 'ยอดคงเหลือ (OPD)',
    claimSubmission: 'ส่งคำขอเรียกร้องค่าสินไหม',
    claimHistory: 'ประวัติการเรียกร้องค่าสินไหม',
    claimHistory2: '',
    downloadDocuments: 'ดาวน์โหลดเอกสาร',
    policyBenefit: 'ผลประโยชน์จากกรมธรรม์',
    inpatientBenefits: 'ค่ารักษาพยาบาลผู้ป่วยใน',
    outPatientBenefits: 'ค่ารักษาพยาบาลผู้ป่วยนอก',
    groupLifeInsuranceBenefits: 'ผลประโยชน์ประกันชีวิตกลุ่ม',
    dentalBenefits: 'ค่ารักษาพยาบาลทันตกรรม',
    maternityBenefits: 'การตั้งครรภ์และการคลอดบุตร',
    majorMedicalBenefits: 'การรักษาการบาดเจ็บหรือป่วยที่มีค่าใช้จ่ายสูง',
    otherBenefits: 'ผลประโยชน์อื่นๆ',
    postHospitalBenefits: 'ค่าปรึกษาแพทย์ต่อเนื่องในฐานะผู้ป่วยนอกหลังการรักษาตัวในโรงพยาบาล',
    preHospitalizationBenefits: 'ค่าปรึกษาแพทย์ในฐานะผู้ป่วยนอกก่อนเข้ารักษาพยาบาลในฐานะผู้ป่วยใน',
    xray: 'ค่าตรวจทางห้องทดลองปฏิบัติการ ในฐานะผู้ป่วยนอก',
    active: 'มีผลบังคับ',
    inactive: 'ไม่มีผลบังคับ',
    outpatientCoverage: 'ความคุ้มครองผู้ป่วยนอก',
    dataUpdateAt: 'ข้อมูลอัปเดต ณ วันที่',
    opdCoverageDesc: 'ยอดคงเหลือความคุ้มครองผู้ป่วยนอก (OPD)',
    opdCoverageSubDesc:
      '* ทั้งนี้วงเงินที่แจ้งอาจยังไม่ได้คำนวณยอดในส่วนค่ารักษาพยาบาลที่ อยู่ระหว่างการดำเนินการส่งเอกสารเรียกร้องสินไหมกับทางบริษัทฯ',
    footerDesc: '*หมายเหตุ เงื่อนไขความคุ้มครองเป็นไปตามที่กำหนดไว้ในกรมธรรม์',
    confirmOK: 'ตกลง',
    notFoundHeader: 'ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
    notFoundDescription: 'ขออภัยค่ะ ไม่พบข้อมูล / ข้อมูลไม่ตรงกับที่บริษัทบันทึกไว้',
    notFoundDescription1: 'กรุณาติดต่อศูนย์ลูกค้าสัมพันธ์',
    notFoundDescription2: 'เพื่อรับความช่วยเหลือ',
    notFoundSubDescription: 'ศึกษาข้อมูลการใช้งานแอปพลิเคชัน หรือ ดูข้อมูลผลิตภัณฑ์เพิ่มเติมที่ ',
    notFoundLinkSubDescription: 'www.krungthai-axa.co.th',
  },

  claimSubmission: {
    typeHealthClaim: 'ผู้ป่วยนอก / OPD',
    cantSubmit1: 'ขออภัย',
    cantSubmit2: 'กรมธรรม์นี้ไม่ครอบคลุมผลประโยชน์ผู้ป่วยนอก',
    cantSubmitDesc1: 'กรมธรรม์นี้ไม่ครอบคลุมผลประโยชน์ผู้ป่วยนอก',
    cantSubmitDesc2: 'กรุณาเลือกกรมธรรม์อื่น',
    claimServiceTitle: 'บริการ OPD Quick Claim',
    claimReqText: 'ส่งคำขอเรียกร้องสินไหมทดแทนกรณี',
    claimOPDText: 'ผู้ป่วยนอก \n',
    claimMaximum: 'ยอดไม่เกิน',
    claimReqDescText:
      '(รวมถึงกรณีทันตกรรม, ตรวจสุขภาพ, วัคซีน และสายตา ตามเงื่อนไขที่ระบุในกรมธรรม์)',
    initiateRequest: 'เริ่มสร้างคำขอ',
    createRequest: 'สร้างคำขอ',
    typesOfHealthClaim: 'ประเภทของการเรียกร้องค่าสินไหมสุขภาพ',
    insuredName: 'ชื่อผู้เอาประกัน',
    insuredFamilyName: 'ชื่อผู้เอาประกัน (กรณีครอบครัวพนักงาน)',
    optional: 'ถ้ามี',
    insuredFamilyNamePlaceholder: 'เลือกชื่อของผู้เอาประกัน',
    email: 'อีเมลเพื่อรับการยืนยันใบคำขอเรียกร้องสินไหม',
    enterEmail: 'กรุณากรอกอีเมล',
    enterEmailConfirm: 'กรุณากรอกยืนยันอีเมล',
    emailDoesNotMatch: 'ยืนยันอีเมลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
    emailFotmatIncorrect: 'รูปแบบอีเมลไม่ถูกต้อง กรุณาลองอีกครั้ง',
    invalidClaimAmount: 'กรุณากรอกจำเนินเงินในการเรียกร้องสินไหมทดแทน',
    confirmEmail: 'ยืนยันอีเมล',
    visitDate: 'วันที่เข้ารับการตรวจรักษา',
    pleaseEnterDate: 'กรุณากรอกวันที่เข้ารับการตรวจรักษา',
    visitDatePlaceholder: 'วว/ดด/ปปปป',
    claimAmount: 'จำนวนเงินในการเรียกร้องสินไหมทดแทน',
    baht: 'บาท',
    bahtUndot: 'บาท',
    selectPolicy: 'เลือกกรมธรรม์ที่ต้องการเรียกร้องสินไหม',
    addPolicy: 'เพิ่มกรมธรรม์',
    createSelectPolicyDesc:
      'สามารถเลือกพร้อมกันได้สูงสุด 5 กรมธรรม์ โดยหักยอดสินไหมจากกรมธรรม์ลำดับแรกก่อนแล้วจึงหักส่วนต่างจากกรมธรรม์ในลำดับต่อไป',
    selectPolicyDesc:
      'สามารถเลือกพร้อมกันได้สูงสุด 5 กรมธรรม์ โดยหักยอดสินไหมจากกรมธรรม์ลำดับแรกก่อนแล้วจึงหักส่วนต่างจากกรมธรรม์ในลำดับต่อไป',
    attachBankBook: 'แนบหน้าแรกของสมุดบัญชี',
    addAttachments: 'เพิ่มไฟล์แนบ',
    attachBankBookDesc: 'บัญชีออมทรัพย์ของผู้เอาประกันเท่านั้น',
    attachTheReceipt: 'แนบใบเสร็จรับเงิน',
    attachTheReceiptDesc:
      'กรุณาระบุข้อความ “ใช้สำหรับการเบิกค่ารักษาพยาบาลกับบริษัท กรุงไทย-แอกซ่า เท่านั้น” ในใบเสร็จรับเงินต้นฉบับด้วย ปากกาสีน้ำเงินก่อนถ่ายรูป',
    attachTheExpenseDetails: 'แนบใบรายละเอียดค่าใช้จ่าย',
    attachMedicalCertificate: 'แนบใบรับรองแพทย์ หรือ ใบสรุปการรักษาจากแพทย์',
    attachMedicalCertificateDesc:
      'สำหรับการเรียกร้องค่าสินไหมสุขภาพที่มีมูลค่าตั้งแต่ 3,000 บาท จำเป็นต้องแสดงรายละเอียดค่าใช้จ่ายในการรักษาด้วยเสมอ',
    claimAmountUpTo: 'ท่านสามารถระบุจำนวนเงินในการเรียกร้องค่าสินไหมได้ไม่เกิน',
    sampleExpenseDetails: 'ตัวอย่างใบรายละเอียดค่าใช้จ่าย',
    sampleExpenseDescript:
      'สำหรับการเรียกร้องค่าสินไหมสุขภาพที่มีมูลค่าตั้งแต่ 3,000 บาท จำเป็นต้องแสดงรายละเอียดค่าใช้จ่ายในการรักษาด้วยเสมอ',
    sampleReceipt: 'ตัวอย่างใบเสร็จรับเงิน',
    sampleReceiptDescription:
      'กรุณาระบุข้อความ “ใช้สำหรับการเบิกค่ารักษาพยาบาลกับบริษัท กรุงไทย-แอกซ่า ประกันชีวิต เท่านั้น” ในใบเสร็จรับเงินต้นฉบับ ด้วยปากกาสีน้ำเงินก่อนถ่ายรูป',
    sampleMedical:
      'ตัวอย่างใบรายงานสำหรับแพทย์ผู้รักษา รายงานแพทย์ กรณีรักษาแบบผู้ป่วยนอก (Medical report for OPD)',
    next: 'ต่อไป',
    back: 'กลับสู่',
    toTop: 'ด้านบน',
    resultSelectPolicyTitle: 'กรมธรรม์ที่ต้องการเรียกร้องสินไหม',
    selectPolicyTitle: 'กรมธรรม์ที่ต้องการเรียกร้องสินไหม',
    selectPolicyPlaceholder: 'เลือกกรมธรรม์ที่ต้องการจากรายการด้านล่าง',
    noOptionPolicy: 'ไม่พบกรมธรรม์อื่นที่ครอบคลุมผลประโยชน์ผู้ป่วยนอก',
    policyCanBeAdded: 'กรมธรรม์ที่สามารถเรียกเพิ่มเติมได้',
    confirmOK: 'ตกลง',
    comfirmRequestClaim: 'ยืนยันและส่งคำขอ',
    policyWantToMakeClaim: 'กรมธรรม์ที่ต้องการเรียกร้องสินไหม',
    attachedClaimsSupportingDocuments: 'เอกสารประกอบการเรียกร้องสินไหมที่แนบมา',
    cancel: 'ยกเลิก',
    submitRequest: 'ส่งคำขอ',

    //
    consentLetter: 'หนังสือให้ความยินยอม',
    consentParagraph1:
      'ข้าพเจ้า ขอให้และยินยอมให้แพทย์ สถานพยาบาล บริษัทประกันภัยอื่น หรือบุคคลที่เกี่ยวข้อง ซึ่งมีข้อมูลส่วนบุคคล ข้อมูลสุขภาพและประวัติการรักษาพยาบาลของข้าพเจ้าที่ผ่านมาหรือจะมีขึ้นในอนาคต เปิดเผยข้อมูลสุขภาพและประวัติการรักษาพยาบาลของข้าพเจ้าให้แก่ บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) บริษัทประกันภัยต่อ รวมถึงให้ความยินยอมสำหรับการแลกเปลี่ยนข้อมูลสุขภาพและประวัติการรักษาพยาบาลของข้าพเจ้าระหว่างบริษัทฯ กับตัวแทนประกันชีวิตของบริษัทฯ หรือผู้แทนของบริษัทฯหรือผู้ถือกรมธรรม์ และ/หรือบริษัทนายหน้าประกันภัย เพื่อการจ่ายเงินตามกรมธรรม์ประกันภัย หรือดำเนินการใดๆ ที่เกี่ยวข้องกับกรมธรรม์ประกันภัย',
    consentParagraph2:
      'ข้าพเจ้ารับทราบว่า บริษัทฯ จะดำเนินการกับข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อประโยชน์ในการปฏิบัติตามข้อผูกพันที่มีตามกรมธรรม์และการให้บริการของบริษัทฯ และทราบถึงรายละเอียดเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อประโยชน์ในการปฏิบัติตามข้อผูกพันที่มีตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลตามที่ปรากฏในนโยบายคุ้มครองข้อมูลส่วนบุคคลแล้ว ดังรายละเอียดที่ระบุไว้ในเว็บไซต์ของบริษัทฯ',
    consentParagraph3:
      'อนึ่ง สำเนาใบหนังสือให้ความยินยอมนี้ถือว่ามีผลบังคับได้เช่นเดียวกับต้นฉบับ ข้าพเจ้าได้ทราบและเข้าใจข้อความตลอดจนเงื่อนไขและวิธีปฏิบัติของบริษัทฯ ตามเอกสารฉบับนี้ เป็นอย่างดีโดยละเอียดครบถ้วนแล้วเห็นว่าถูกต้องตามเจตนาของข้าพเจ้าจึงได้ตกลงยินยอมผูกพันปฏิบัติตามเงื่อนไข และวิธีปฏิบัติของบริษัทฯ ตามเอกสารฉบับนี้ เป็นอย่างดีโดยละเอียดครบถ้วนแล้วเห็นว่าถูกต้องตามเจตนาของข้าพเจ้าจึงได้ตกลงยินยอมผูกพันปฏิบัติตามเงื่อนไข และวิธีปฏิบัติของบริษัทฯ ทุกประการ',
    remark: 'หมายเหตุ',
    remark1: 'กรณีผู้เอาประกันภัยเป็นผู้เยาว์ ให้ผู้ปกครองลงนามแทนพร้อมระบุความสัมพันธ์',
    remark2:
      'กรณีผู้เอาประกันเป็นผู้เยาว์อายุมากกว่า 10 ปี แต่ไม่ถึง 20 ปีบริบูรณ์ ให้บิดา/มารดา ผู้ปกครองที่ชอบด้วยกฎหมายลงนามร่วมกับผู้เยาว์พร้อมระบุความสัมพันธ์',
    remark3: 'กรณีลงนามโดยใช้วิธีพิมพ์ลายนิ้วมือ ต้องมีพยานลงนามรับรอง 2 ท่าน',
    confirm: 'ยืนยัน',

    //
    successTitle: 'ส่งคำขอเรียกร้องสินไหมทดแทนเรียบร้อยแล้ว',
    successSubtitle: 'การทำรายการนี้เป็นการส่งการเรียกร้องค่าสินไหมซึ่งผลการพิจารณา',
    successSubtitle2:
      'จะขึ้นอยู่กับเงื่อนไขกรมธรรม์ โดยท่านจะทราบสถานะการเรียกร้องสินไหมเบื้องต้นภายใน 3-5 วันทำการ',
    typesOfClaim: 'ประเภทของการเรียกร้องค่าสินไหมสุขภาพ',
    since: 'เมื่อ',
    requestDate: 'วันที่ส่งคำขอ',
    backHome: 'กลับหน้าหลัก',
    failTitle: 'ไม่สามารถบันทึกคำขอได้ในขณะนี้',
    failSubtitle:
      'ขออภัย ระบบไม่สามารถดำเนินการบันทึกเรียกร้องสินไหมสุขภาพของท่านได้ในขณะนี้ \n กรุณาลองใหม่อีกครั้งภายหลัง',
    cancelTitle: 'ยกเลิกคำร้องขอค่าสินไหมทดแทน?',
    cancelDesc1: 'ระบบจะไม่บันทึกข้อมูล หากต้องการยกเลิกการทำรายการ',
    cancelDesc2: 'เลือก "ยกเลิกคำขอ" หรือต้องการทำต่อเลือก "ทำต่อ"',
    cancelDesc3: '',
    cancelContinue: 'ทำต่อ',
    cancelButton: 'ยกเลิกคำขอ',
    closeButton: 'ตกลง',
    maxAttachedFileTitle: 'ถึงขนาดสูงสุดของขีดจำกัดไฟล์แล้ว',
    maxAttachedFileDetail: 'กรุณาอัปโหลดไฟล์ที่มีขนาดโดยรวมทั้งหมดต่ำกว่า 5 MB',
    warningMaxAttachFile:
      'ขนาดไฟล์แนบทั้งหมดหลังจากระบบจัดการไม่ควรเกิน 5 MB \n ขนาดปัจจุบันเท่ากับ {SIZE} MB',
  },

  month: {
    January: 'มกราคม',
    February: 'กุมภาพันธ์',
    March: 'มีนาคม',
    April: 'เมษายน',
    May: 'พฤษภาคม',
    June: 'มิถุนายน',
    July: 'กรกฎาคม',
    August: 'สิงหาคม',
    September: 'กันยายน',
    October: 'ตุลาคม',
    November: 'พฤศจิกายน',
    December: 'ธันวาคม',
  },

  sidebar: {
    hello: 'สวัสดี',
    myPolicies: 'กรมธรรม์ของฉัน',
    claim: 'การเรียกร้องสินไหม',
    claimInquiry: 'ประวัติการเรียกร้องสินไหม',
    claimSubmission: 'ส่งคำร้องสินไหม',
    hospitalNetwork: 'สถานพยาบาลในเครือข่าย',
    logout: 'ออกจากระบบ',
    logoutDes: 'คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?',
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
  },

  claim: {
    claimInquiryText: 'ประวัติการเรียกร้องสินไหม',
    policyCoverageText: 'กรมธรรม์และการคุ้มครอง',
    historyText: 'ประวัติการเรียกร้องสินไหม',
    'Group Health Package': 'ประกันกลุ่มแบบคุ้มครองสินเชื่อ',
    'Group PA Package': 'ประกันอุบัติเหตุกลุ่ม',
    'Group Credit Life': 'ประกันกลุ่มแบบคุ้มครองสินเชื่อ',
    policyPast1Year: 'ทุกกรมธรรม์ย้อนหลัง 1 ปี',
    currentlyViewing: 'คุณกำลังดูรายการของคุณ...',
    selectPolicyYear: 'เลือกจากปีกรมธรรม์',
    allPolicyPast: 'รายการกรมธรรม์ย้อนหลัง 1 ปี',
    activeText: 'มีผลบังคับ',
    inactiveText: 'ไม่มีผลบังคับ',
    backToTopButton: 'กลับสู่ \t ด้านบน',
  },
  claimHistory: {
    claimInfo: 'รายละเอียดการเรียกร้องสินไหม',
    cutOffDate: 'วันที่ตัดรอบ',
    remarkPolicyYear: 'หมายเหตุตามปีกรมธรรม์',
    remarkExpense: 'หมายเหตุตามค่าใช้จ่าย',
    sumExMed: 'ผลรวมค่าใช้จ่าย Med',
    sumExHb: 'ผลรวมค่าใช้จ่าย Hb',
    sumExPa: 'ผลรวมค่าใช้จ่าย Pa',
    serviceTypeGroup: 'ประเภทสินไหม',
    notifyNo: 'ประเภทสินไหม',
    rider: 'สัญญาเพ่ิมเติม',
    submitDate: 'วันที่นำส่งสินไหม',
    registerDate: 'วันที่บันทึกรับเอกสาร',
    admitDate: 'วันที่เข้ารับการรักษา',
    dischargeDate: 'วันที่ออกจากโรงพยาบาล',
    approveDate: 'วันที่อนุมัติสินไหม',
    paymentDate: 'วันที่จ่ายสินไหม',
    accidentDate: 'วันที่เกิดอุบัติเหตุ',
    serviceTypeCode: 'ประเภทสินไหม',
    serviceTypeDescription: 'ประเภทบริการ',
    claimStatusCode: 'รหัสสถานะคำร้องขอเอาประกัน',
    claimStatus: 'สถานะการเรียกร้องสินไหม',
    historyFlag: 'ประวัติสถานะ',
    pendingFlag: 'สถานะรอดำเนินการ',
    apiPolicyYear: 'API ปีกรมธรรม์',
    apiText: 'ปีกรมธรรม์ (ปีปัจจุุบัน)',
    charge: 'จำนวนเงินค่ารักษาพยาบาลที่เรียกร้อง',
    discount: 'ส่วนลดโรงพยาบาล',
    nonCover: 'ยอดที่ไม่คุ้มครอง',
    paid: 'ยอดอนุมัติสินไหม',
    overPaid: 'ส่วนเกินสิทธิ์',
    exgratia: 'จำนวนเงินสินไหมอนุโลม',
    overalLimit: 'วงเงินความคุ้มครอง',
    coPayTotal: 'จำนวนเงินค่าใช้จ่ายร่วม',
    suborgration: 'จำนวนเงินเรียกเก็บคืน',
    assessmentStatus: 'สถานะขั้นตอนการพิจารณาสินไหม',
    customerCharge: 'ค่าใช้จ่ายของผู้เอาประกัน',
    customerPaid: 'ยอดที่ผู้เอาประกันจ่าย',
    customerException: 'ข้อยกเว้นของผู้เอาประกัน',
    icd10_1_code: 'รหัสโรคที่รักษาหลัก',
    icd10_1_desc: 'ชื่อโรคภาษาไทย',
    icd10_2_code: 'รหัสโรครักษาร่วม',
    icd10_2_desc: 'ชื่อโรครักษาร่วม',
    icd10_3_code: 'รหัสโรคแทรกซ้อน',
    icd10_3_desc: 'ชื่อโรคแทรกซ้อนภาษาไทย',
    claimDetails: 'รายละเอียดการเรียกร้องสินไหม',
    claimHistoryText: 'รายการเรียกร้องสินไหม',
    claimNo: 'หมายเลขการเรียกร้องสินไหม',
    paidHospitalNetworkText: 'อนุมัติการใช้สิทธิ์ผ่านโรงพยาบาล',
    claimDetail: 'ข้อมูลการเรียกร้องสินไหม',
    notifyDate: 'วันที่รับเอกสาร/วันที่รับแจ้ง',
    discoverDetails: 'ข้อมูลโดยละเอียด',
    serviceType: 'ประเภทบริการ',
    inpatient: 'ผู้ป่วยใน',
    hospital: 'โรงพยาบาล',
    clientMailAddress: 'ที่อยู่ไปรษณีย์ของลูกค้า',
    address: 'ที่อยู่',
  },
  claimHistoryStatus: {
    'Claim History Status': 'สถานะการเรียกร้องสินไหม',
    admitDate: 'วันที่เข้ารับการรักษา',
    nonCover: 'ยอดที่ไม่คุ้มครอง',
    overPaid: 'ส่วนเกินสิทธิ์',
    notifyDate: 'วันที่รับเอกสาร/วันที่รับแจ้ง',
  },
  claimHistoryDetail: {
    faxClaimExpenseDetail: 'รายละเอียดค่าใช้จ่ายในการร้องขอสินไหม',
    dailyRoomBoard: 'Daily Room & Board',
    icuAdmission: 'I.C.U. Admission',
    generalHospitalServices: 'General Hospital Services',
    ambulanceServices: 'Ambulance Services',
    nursingServices: 'Nursing Services',
    specialistConsultationFee: 'Specialist Consultation Fee',
    doctorVisit: 'Doctor Visit',
    viewDetails: 'View Details',
    day: 'วัน',
    charge: 'Charge',
    times: 'Times',
    cover: 'Cover',
    paid: 'ชำระ',
    surgeonFee: 'Surgeon fee as per non surgical scheduler',
    majorMedicalGeneral: 'Major medical pay 80% General Hospital Services',
    majorMedicalDailyRoom: 'Major medical pay 80% Daily Room & Board',
    majorMedicalSurgicalFee: 'Major medical pay 80% Surgical fee',
  },
  insurance: {
    myInsurance: 'รายการบัตรประกันของฉัน',
  },
  insuranceGroup: {
    insuranceGroup: 'ประกันชีวิตและสุขภาพกลุ่ม',
    policyOwner: 'เจ้าของกรมธรรม์',
  },
  insuranceDetail: {
    myInsuranceCardTitle: 'บัตรประกันของฉัน',
    flipBackText: 'พลิกดูด้านหลัง',
    downloadText: 'ดาวน์โหลด',
    backward: 'ย้อนกลับ',
    eCard: 'บัตรอิเล็กทรอนิกส์',
  },

  mobileHeader: {
    groupHealthPackage: 'ประกันชีวิตและสุขภาพกลุ่ม',
    myAccount: 'บัญชีผู้ใช้งาน',
  },
  _policyCoverage: {
    'Group Health Package': 'ประกันชีวิตและสุขภาพกลุ่ม',
    'Group PA Package': 'ประกันอุบัติเหตุกลุ่ม',
    'Group Credit Life': 'ประกันกลุ่มแบบคุ้มครองสินเชื่อ',
    THB: 'บาท',
    times: 'ครั้ง',
  },
  termsList: {
    header: 'ข้อกำหนดและเงื่อนไขในการใช้บริการ "Group Employee Portal"',
    headerCut: 'ข้อกำหนดและเงื่อนไขในการใช้บริการ "Group Employee Portal"',
    headerAppName: '',
    subHeader:
      'ในการใช้บริการเว็บแอปพลิเคชันของบริษัทตามรายละเอียดการให้บริการที่บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) (“บริษัท”) กำหนด ท่านตกลงผูกพันตามข้อกำหนดและเงื่อนไข ดังต่อไปนี้',
    termsCondition1: 'คำนิยาม',
    termsCondition2: 'วัตถุประสงค์ของระบบ',
    termsCondition3: 'วิธีการเข้าใช้งานระบบ',
    termsCondition4: 'การใช้บริการระบบ',
    termsCondition5: 'ข้อจำกัดความรับผิด',
    termsCondition6: 'ขอบเขตอำนาจศาล',
    termsCondition7: 'การเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคล',
    data11:
      '1.1.	“Group Employee Portal” หมายความถึง เว็บแอปพลิเคชันสำหรับให้บริการแก่ผู้เอาประกันภัยกลุ่มของบริษัท ต่อไปในที่นี้ เรียกรวมกันว่า "ระบบ"',
    data12:
      '1.2.	“เครื่องมือเพื่อการทำรายการ” หมายความถึง เครื่องคอมพิวเตอร์ โทรศัพท์มือถือ แท็บเล็ต และ/หรือเครื่องมืออื่นตามที่บริษัทกำหนดเพื่อเข้าใช้บริการระบบ',
    data13:
      '1.3.	“กรมธรรม์ประกันภัยกลุ่ม” หมายความถึง กรมธรรม์ประกันภัยกลุ่มของบริษัทที่ผู้เอาประกันภัยเป็นสมาชิก',
    data14:
      '1.4.	“ผู้เอาประกันภัย” หมายความถึง ผู้เอาประกันภัยตามคำนิยามที่กำหนดไว้ในกรมธรรม์ประกันภัยกลุ่ม',
    data21:
      'เว็บแอปพลิเคชันนี้ (ต่อไปในที่นี้ เรียกรวมกันว่า "ระบบ") มีวัตถุประสงค์เพื่อให้บริการแก่ผู้เอาประกันภัยกลุ่มของบริษัทและนำเสนอผลิตภัณฑ์หรือบริการที่เกี่ยวข้องเท่านั้น',
    data31:
      'ท่านสามารถเข้าใช้งานโดยเข้าถึงระบบนี้ตามที่อยู่เว็บไซต์ (URL) ที่บริษัทกำหนด และใช้หมายเลขประจำตัวประชาชนหรือหนังสือเดินทาง และหมายเลขโทรศัพท์เคลื่อนที่ที่ท่านได้ให้ไว้กับบริษัท ในการเข้าสู่ระบบ หากข้อมูลถูกต้อง บริษัท จะส่งรหัสผ่านใช้ครั้งเดียวผ่านข้อความเอสเอ็มเอสไปยังหมายเลขโทรศัพท์ของท่านที่ได้ให้ไว้กับบริษัท สำหรับเข้าใช้งานระบบ',
    data41: '4.1.	ท่านตกลงผูกพันและปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการตามที่บริษัทกำหนด',
    data42: '4.2.	เมื่อท่านเข้าถึงหรือใช้งานระบบนี้ ท่านรับรองว่าท่านคือผู้เอาประกันภัย',
    data43:
      '4.3.	ข้อมูลที่อยู่ในระบบนี้มิได้แสดงข้อกำหนดและเงื่อนไขกรมธรรม์ที่เกี่ยวข้องทั้งหมดหรือบางส่วน ขอแนะนำให้ท่านอ่านเอกสารกรมธรรม์อย่างละเอียด และทำความเข้าใจในข้อกำหนดและเงื่อนไขของกรมธรรม์ด้วยตัวท่านเอง นอกจากนี้ การใช้ระบบนี้ มิได้ทำให้ท่านหลุดพ้นจากความรับผิดชอบในการปฏิบัติตามข้อกำหนดตามกฎระเบียบใด ๆ หรือหลักปฏิบัติทั่วไปเกี่ยวกับอุบัติเหตุหรือการเรียกร้องค่าสินไหมทดแทน',
    data44:
      '4.4.	การเข้าถึงบริการและการสมัครรับผลิตภัณฑ์ประกันภัยใด ๆ ที่แสดงอยู่ในระบบนี้ อาจจำกัดไว้สำหรับบุคคลบางคนหรือในบางประเทศเท่านั้น บริษัทจะไม่ให้บริการและจำหน่ายผลิตภัณฑ์แก่บุคคล หากกฎหมายในประเทศถิ่นกำเนิดของบุคคลนั้นหรือประเทศอื่นใดที่เกี่ยวข้องกับบุคคลนั้นห้ามมิให้บริการและจำหน่าย อย่างไรก็ตาม ขึ้นอยู่กับว่าบุคคลทั้งหมดที่เกี่ยวข้องได้ตรวจสอบกับที่ปรึกษากฎหมายของตนก่อนแล้วว่า สถานะทางกฎหมายและทางการเงินของตนเอื้อให้ตนมีสิทธิรับบริการและสมัครรับผลิตภัณฑ์ที่แสดงในระบบนี้',
    data45:
      '4.5.	ในการส่งข้อมูลเกี่ยวกับการเรียกร้องค่าสินไหมทดแทนของผู้เอาประกันภัย ท่านรับรองว่าท่านคือผู้เอาประกันภัย และยอมรับข้อกำหนดและเงื่อนไขนี้ ตลอดจนคำแถลงในการเก็บรวบรวมข้อมูลส่วนบุคคล  ท่านมีหน้าที่รับผิดชอบอย่างเต็มที่เพื่อให้การดำเนินการดังกล่าวมีผลสมบูรณ์ และตกลงว่าจะชดใช้ให้แก่บริษัทหากเกิดความเสียหายหรือการเรียกร้องใด ๆ จากการดำเนินการดังกล่าว',
    data46:
      '4.6.	นโยบายคืน/คืนเงิน/ยกเลิกของบริษัท (ถ้ามี) จะระบุอยู่ในกรมธรรม์ประกันภัยที่เกี่ยวข้องซึ่งท่านได้สมัครไว้แล้ว  มิเช่นนั้นจะไม่มีการคืน/คืนเงินเบี้ยประกันภัย หากท่านยกเลิกกรมธรรม์ประกันภัย',
    data47:
      '4.7.	ขณะป้อนที่อยู่ของท่านเพื่อสมัครผลิตภัณฑ์ประกันภัยใด ๆ โปรดอย่าป้อนคำว่า "Care of" และ/หรือที่อยู่ชั่วคราว เช่น ที่อยู่ของอินเทอร์เน็ตคาเฟ่',
    data48:
      '4.8.	ข้อมูลทั้งหมดในข้อกำหนดและเงื่อนไขนี้อาจมีการเปลี่ยนแปลงโดยไม่ได้บอกกล่าวล่วงหน้า ท่านเข้าใจดีว่า ท่านต้องยอมรับข้อกำหนดและเงื่อนไขดังกล่าวข้างต้นนี้ก่อน จึงจะสามารถเข้าถึงและ/หรือใช้งานระบบได้ ดังนั้น ท่านจึงยอมรับและตกลงที่จะปฏิบัติตามข้อกำหนดดังกล่าว',
    data51:
      '5.1.	การที่บริษัทยอมรับข้อมูลใด ๆ ที่ท่านจัดหาให้ผ่านระบบนี้ จะไม่ถือหรือนำมาตีความเป็นการยอมรับผิดของบริษัท  ในการวินิจฉัยการเรียกร้องค่าสินไหมทดแทน ส่วนหนึ่งจะพิจารณาจากข้อมูลที่นำส่งแก่บริษัทผ่านทางระบบนี้ และท่านรับประกันและรับรองว่าข้อมูลดังกล่าวเป็นความจริงและถูกต้อง และข้อมูลทั้งหมดที่อาจมีนัยสำคัญไม่ว่าในลักษณะใดต่อการเรียกร้องค่าสินไหมทดแทน ได้รับการเปิดเผยอย่างครบถ้วนแล้ว  ขอเรียนให้ทราบว่าข้อกำหนดที่แสดงอยู่นี้เป็นเพียงการบ่งชี้ให้เห็นเท่านั้น มิได้ครอบคลุมทั้งหมด และบริษัทอาจจำเป็นต้องขอให้ผู้เอาประกันภัยจัดหาข้อมูล เอกสาร และหลักฐานการเรียกร้องค่าสินไหมทดแทนเพิ่มเติม เพื่อประกอบการพิจารณาค่าสินไหมทดแทนของผู้เอาประกันภัยนั้น ทั้งนี้ ขึ้นอยู่กับพฤติการณ์ของแต่ละกรณี ความรับผิดในการชดใช้จะต้องอยู่ภายใต้บังคับตามข้อกำหนดและเงื่อนไขของกรมธรรม์ที่เกี่ยวข้องตลอดเวลา',
    data52:
      '5.2.	แม้ว่าจะใช้ความพยายามอย่างสุดความสามารถเพื่อให้แน่ใจว่าข้อมูลที่อยู่ในหรือที่เข้าถึงผ่านระบบนี้ถูกต้องแล้ว บริษัทไม่ขอรับรองหรือรับประกันความถูกต้อง ความเพียงพอ ความเป็นที่ยอมรับ ความสมเหตุสมผล หรือความครบถ้วนสมบูรณ์ไม่ว่าในลักษณะใดของข้อมูลดังกล่าว หรือยอมรับผิดต่อความสูญเสียหรือความเสียหาย ไม่ว่าทั้งหมดหรือบางส่วน ไม่ว่าโดยตรงหรือโดยอ้อม อันเกิดจากความผิดพลาด ความไม่ถูกต้อง หรือการละเว้นการกระทำใด ๆ',
    data53:
      '5.3.	ไม่มีการรับประกันประเภทใด ๆ (ไม่ว่าจะเป็นโดยปริยาย โดยชัดแจ้ง ตามกฎหมาย หรือประการอื่นใด) ในส่วนของข้อมูลที่อยู่ในหรือที่เข้าถึงผ่านระบบนี้หรือตัวระบบนี้โดยทั่วไป',
    data54:
      '5.4.	เมื่อท่านเข้าถึงหรือใช้งานระบบนี้ ท่านตกลงอย่างชัดแจ้งว่า ท่านยอมรับความเสี่ยงจากการเข้าถึงหรือใช้งานดังกล่าว บริษัทไม่ขอรับผิดชอบใด ๆ และไม่ต้องรับผิดต่อความสูญเสียหรือความเสียหายใด ๆ อันเป็นผลมาจากการที่ท่านเข้าถึงหรือใช้งานระบบนี้ ตลอดจนการดาวน์โหลดหรือใช้งานข้อมูลใด ๆ',
    data55:
      '5.5.	ท่านรับทราบว่าท่านทราบดีและตกลงอย่างชัดแจ้งว่า ในการใช้งานระบบนี้ บริษัทจะติดตามตรวจสอบและบันทึกกิจกรรมทั้งหมดของท่านที่ดำเนินการในระบบนี้',
    data56:
      '5.6.	ในกรณีที่ข้อมูลในหรือที่เข้าถึงผ่านระบบนี้ ขัดแย้งกับกรมธรรม์ที่เกี่ยวข้อง ให้ข้อกำหนดในกรมธรรม์ดังกล่าวและกรมธรรม์ฉบับแก้ไขใด ๆ มีผลเหนือกว่า ทั้งนี้เท่าที่ขัดแย้งกันเท่านั้น',
    data57:
      '5.7.	บริษัทไม่ขอรับรองหรือรับประกันว่า ระบบนี้จะพร้อมใช้ตลอดเวลา และจะไม่มีการรบกวนการเข้าถึง ข้อบกพร่องต่าง ๆ จะได้รับการแก้ไขให้ถูกต้อง ข้อมูลที่ส่งไม่มีความล่าช้า ไม่ล้มเหลว ไม่มีความผิดตกละเว้น หรือความเสียหายใด ๆ ไม่มีการส่งไวรัสหรือสิ่งปนเปื้อนหรือสิ่งที่ทำลายระบบอื่นใด หรือจะไม่เกิดความเสียหายกับเครื่องมือเพื่อทำรายการของท่านจากการเข้าใช้งานระบบ ท่านมีหน้าที่รับผิดชอบแต่เพียงผู้เดียวตามสมควร ในการคุ้มครองป้องกันเครื่องมือเพื่อทำรายการของท่านและการสำรองข้อมูล',
    data58:
      '5.8.	ที่อยู่อีเมลของท่านไม่ได้อยู่ในความควบคุมของบริษัท และบริษัทไม่รับผิดชอบต่อเนื้อหาของที่อยู่อีเมลของท่าน การเข้าถึงและใช้งานที่อยู่อีเมลของท่านเป็นความเสี่ยงของท่านเอง และอยู่ภายใต้บังคับตามข้อกำหนดและเงื่อนไขใด ๆ ที่เกี่ยวข้องกับการเข้าถึง/การใช้งานเช่นว่านั้น  การที่บริษัทจัดให้มีไฮเปอร์ลิงก์หรือการเชื่อมต่อไปยังที่อยู่อีเมลของท่าน จะไม่ถือว่าบริษัทรับรอง ชี้แนะ เห็นชอบ รับประกัน หรือแนะนำให้แก่บุคคลอื่นใดหรือบริการ/ผลิตภัณฑ์/เนื้อหาที่บุคคลอื่นดังกล่าวจัดให้มีในระบบ/แพลตฟอร์มของตน หรือมีในรูปแบบความร่วมมือใด ๆ กับบุคคลอื่นดังกล่าว และระบบ/แพลตฟอร์มดังกล่าว  บริษัทไม่ใช่คู่สัญญาที่เข้าทำระหว่างท่านกับผู้ให้บริการระบบ/แพลตฟอร์มภายนอก เว้นแต่ว่าบริษัทได้ระบุหรือตกลงเป็นประการอื่นไว้อย่างชัดแจ้ง',
    data59:
      '5.9.	อีเมลและการติดต่ออื่น ๆ ที่ส่งไปยังบริษัทและ/หรือระบบนี้ผ่านทางอินเทอร์เน็ต ไม่สามารถรับประกันได้ว่าปลอดภัยอย่างสมบูรณ์ บริษัทไม่ต้องรับผิดชอบต่อความเสียหายใด ๆ ที่เกิดกับท่าน หากท่านส่งอีเมล/ข้อความไปถึงบริษัทหรือหากบริษัทส่งอีเมล/ข้อความไปถึงท่านตามที่ท่านขอ ผ่านทางอินเทอร์เน็ต',
    data510:
      '5.10. เนื่องจากลักษณะของอินเทอร์เน็ต ธุรกรรมหรือการติดต่อสื่อสารทั้งหลายจึงอาจเกิดการหยุดชะงัก การส่งข้อมูลขัดข้อง การส่งข้อมูลล่าช้า และการส่งข้อมูลไม่ถูกต้องได้  บริษัทไม่ต้องรับผิดต่อกรณีที่เกิดการขัดข้องของระบบติดต่อสื่อสารที่ไม่อยู่ในความควบคุมของบริษัท ซึ่งอาจส่งผลกระทบต่อความถูกต้องหรือความเหมาะสมของเวลาในการติดต่อสื่อสารและธุรกรรมที่ท่านส่งหรือได้รับ',
    data511:
      '5.11. หากข้อความใดในข้อกำหนดและเงื่อนไขนี้ไม่มีผลสมบูรณ์ ข้อความส่วนที่เหลือของข้อกำหนดและเงื่อนไขนี้จะยังคงมีผลบังคับใช้ได้ต่อไป หากข้อความใดในข้อกำหนดและเงื่อนไขนี้ไม่ชอบด้วยกฎหมาย เป็นโมฆะ หรือไม่สามารถบังคับใช้ได้ ข้อความนั้นจะถือว่าแยกส่วนจากข้อกำหนดและเงื่อนไขนี้ และข้อความส่วนที่เหลือยังคงมีผลสมบูรณ์และบังคับใช้ได้',
    data61:
      '6.1.	ข้อกำหนดและเงื่อนไขนี้ให้อยู่ภายใต้การกำกับดูแลและจะตีความตามกฎหมายของราชอาณาจักรไทย ท่านและบริษัทตกลงจะนำขึ้นยื่นต่อเขตอำนาจที่ไม่ผูกขาดของศาลแห่งราชอาณาจักรไทยเพื่อขอระงับข้อพิพาทใดๆ ซึ่งอาจเกิดจากข้อกำหนดและเงื่อนไขนี้',
    data71:
      '7.1.	ท่านรับทราบและตกลงว่า บริษัทอาจเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านที่ให้ไว้หรือมีอยู่กับบริษัท หรือที่บริษัทได้รับหรือเข้าถึงจากแหล่งอื่น ให้แก่ หน่วยงาน / องค์กร / นิติบุคคลใดๆ ที่บริษัทเป็นคู่สัญญาหรือมีความสัมพันธ์ด้วย หรือหน่วยงานหรือคณะกรรมการที่มีอำนาจตามกฎหมายประกาศกำหนด โดยมีวัตถุประสงค์เพื่อสนับสนุนการให้บริการของบริษัท เช่น การพิจารณาสินไหม การที่บริษัทจ้างหรือมอบหมายให้บุคคลอื่นดำเนินการแทน ไม่ว่าทั้งหมดหรือบางส่วน ทั้งภายในหรือภายนอกประเทศไทย เช่น บริษัทประกันภัย บริษัทประกันภัยต่อ ผู้ตรวจพิสูจน์ทางการแพทย์ ผู้ตรวจสอบด้านสินไหม และสมาคม/สมาพันธ์อุตสาหกรรม ฯลฯ เพื่อวัตถุประสงค์ในการให้บริการหลังการขายแก่ลูกค้าได้ รวมถึงพฤติกรรมการท่องเว็บผ่านคุกกี้และการใช้ระบบสำหรับการวิเคราะห์ข้อมูลต่างๆ เพื่อประโยชน์ในการปรับปรุงประสบการณ์การใช้งานของท่านให้ดียิ่งขึ้น',
    data72:
      '7.2.	ท่านรับทราบและเข้าใจดีว่าท่านสามารถศึกษาเพิ่มเติมเกี่ยวกับวัตถุประสงค์ในการใช้งานข้อมูลส่วนบุคคล ตลอดจนสิทธิของท่านดังที่ระบุไว้ในนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัทได้ที่',
    data72link: 'https://www.krungthai-axa.co.th/th/compliance/privacy-policy',
    subFooter: 'ทั้งนี้ เมื่อท่านสมัครเข้าใช้งานระบบนี้ บริษัทจะใช้ข้อมูลของท่านตามที่ระบุใน',
    linkSubFooter: 'นโยบายรักษาความปลอดภัยของข้อมูล',
    footer:
      'เมื่อคลิกปุ่ม “ยอมรับ” ข้าพเจ้าตกลงว่า บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) และ/หรือบริษัทที่เกี่ยวข้อง อาจเก็บรักษา ใช้งาน หรือเปิดเผยข้อมูลใด ๆ ที่รวบรวมหรือยึดถือไว้ ให้แก่บุคคลภายนอก (ภายในหรือภายนอกประเทศไทย เช่น บริษัทประกันภัย บริษัทประกันภัยต่อ ผู้ตรวจพิสูจน์ทางการแพทย์ ผู้ตรวจสอบด้านสินไหม และสมาคม/สมาพันธ์อุตสาหกรรม ฯลฯ) เพื่อวัตถุประสงค์ในการให้บริการหลังการขายแก่ลูกค้าได้',
    accept: 'ยอมรับ',
  },
  header: {
    claim: 'ประวัติการเรียกร้องสินไหม',
    claimSubmission: 'ส่งคำขอเรียกร้องค่าสินไหมทดแทน',
    addPolicy: 'เพิ่มกรมธรรม์',
    claimDetail: 'Claim Detail',
    claimHistoryGroup: 'ประวัติการเรียกร้องสินไหม',
    claimHistory: 'สถานะการเรียกร้องสินไหม',
    claimHistoryDetail: 'Claim History Detail',
    claimSelectPolicyYear: 'ประกันชีวิตและสุขภาพกลุ่ม',
    claimPolicyCoverage: 'Claim Policy Coverage',
    myInsurance: 'บัตรประกันของฉัน',
    profile: 'บัญชีผู้ใช้งาน',
    policyCoverage: 'ประกันชีวิตและสุขภาพกลุ่ม',
    fullYearCoverage: 'ประกันชีวิตและสุขภาพกลุ่ม',
    policyMember: 'ประกันชีวิตและสุขภาพกลุ่ม',
    documentDownload: 'ดาวน์โหลดเอกสาร',
  },
  bankName: {
    UOB: 'ธนาคารกรุงไทย',
  },
  coverageGroup: {
    inPatientBenefitLumpSum: 'ค่ารักษาพยาบาลผู้ป่วยใน (แบบผลประโยชน์จำกัดต่อปี)',
    inPatientBenefitPerDisability: 'ค่ารักษาพยาบาลผู้ป่วยใน (ต่อการเจ็บป่วย/บาดเจ็บต่อครั้ง)',
    majorMedicalLumpSum: 'การรักษาการบาดเจ็บหรือป่วยที่มีค่าใช้จ่ายสูง (แบบผลประโยชน์จำกัดต่อปี)',
    majorMedicalPerDisability:
      'การรักษาการบาดเจ็บหรือป่วยที่มีค่าใช้จ่ายสูง (Major Medical) (ต่อการเจ็บป่วย/บาดเจ็บต่อครั้ง)',
    preHospitalisation:
      'ค่าปรึกษาแพทย์ในฐานะผู้ป่วยนอกก่อนเข้ารักษาพยาบาลในฐานะผู้ป่วยใน (ต่อการเจ็บป่วย/บาดเจ็บต่อครั้ง)',
    postHospitalisation:
      'ค่าปรึกษาแพทย์ต่อเนื่องในฐานะผู้ป่วยนอกหลังการรักษาตัวในโรงพยาบาล (ต่อการเจ็บป่วย/บาดเจ็บต่อครั้ง)',
    outPatientBenefit: 'ค่ารักษาพยาบาลผู้ป่วยนอก',
    laboratoryTest: 'ค่าตรวจทางห้องทดลองปฏิบัติการในฐานะผู้ป่วยนอก',
    mentalHealth: 'การรักษาด้านจิตเวช',
    optical: 'ค่าใช้จ่ายสำหรับอุปกรณ์เพื่อช่วยในการมองเห็น',
    medicalExpenseFromAccident: 'ค่ารักษาพยาบาลเนื่องจากอุบัติเหตุ',
    dentalPerVisit: 'การรักษาทันตกรรม (แบบผลประโยชน์จำกัดต่อการรักษาพยาบาลต่อครั้ง)',
    dentalLumpSum: 'การรักษาทันตกรรม (แบบผลประโยชน์จำกัดต่อปี)',
    maternity: 'การตั้งครรภ์และการคลอดบุตร',
    none: 'ไม่มี',
  },
  coverageIPDLumpSum: {
    rb: '1. ค่าห้อง และค่าอาหารต่อวัน',
    icu: '    ค่าห้อง ค่าอาหาร ห้องผู้ป่วยหนัก (ไอ.ซี.ยู) ต่อวัน (2 เท่าของข้อ 1)',
    doct_fee: 'ค่าแพทย์ตรวจรักษาในโรงพยาบาล',
    ss_sa: 'ค่าแพทย์ผ่าตัดและหัตถการ (ตามจ่ายจริง)',
    ghe1: 'ค่ารักษาพยาบาลอื่น ๆ',
    consult: 'ค่าปรึกษาแพทย์เฉพาะทาง',
    ipdGruop:
      'จำนวนเงินที่จ่ายจริง แต่เมื่อรวมกับผลประโยชน์ที่จ่ายในข้อ 1 ไม่เกินจำนวนเงินผลประโยชน์รวมสูงสุดต่อปีกรมธรรม์',
    ghe21: 'จำนวนเงินผลประโยชน์รวมสูงสุดต่อปีกรมธรรม์',
    ghe22:
      'ค่าใช้จ่ายร่วม (Copayment) ที่ผู้เอาประกันภัยต้องร่วมรับผิดชอบค่าใช้จ่ายในการรักษาพยาบาล อันจะพึงจ่ายตามจำนวนเงินผลประโยชน์',
  },
  coverageMajorMedLumpSum: {
    groupDescription:
      'จำนวนเงินที่จ่ายจริง เมื่อรวมกับผลประโยชน์ที่จ่ายในข้อ 1 และข้อ 2 ไม่เกินจำนวนเงินผลประโยชน์รวมสูงสุด',
  },
  csBenefit: {
    maxiumBenefitPerYear: 'ผลประโยชน์รวมสูงสุดต่อปี',
    areaCoverage: 'อาณาเขตความคุ้มครอง',
    ipd: 'ค่ารักษาพยาบาลในฐานะผู้ป่วยใน',
    opd: 'ค่ารักษาพยาบาลในฐานะผู้ป่วยนอก',
    otherBenefits: 'ค่ารักษาพยาบาลสำหรับผลประโยชน์อื่นๆ',
  },
  coverage: {
    ab: 'ค่ารถพยาบาล',
    aet: 'ค่ารักษาพยาบาลฉุกเฉินเนื่องจากอุบัติเหตุ ',
    anes: 'ค่าวางยาสลบ',
    ath: 'ค่ารักษาโดยแพทย์ทางเลือก',
    cancer_chemo: 'ค่ารักษาโรคมะเร็ง โดยเคมีบำบัด',
    cancer_radio: 'ค่ารักษาโรคเนื้องอกหรือมะเร็ง โดยรังสีรักษา',
    chronic: 'ขยายความคุ้มครองโรคเรื้อรัง',
    congenital: 'ขยายความคุ้มครองโรคที่เป็นมาแต่กำเนิด',
    consult: 'ค่าปรึกษาแพทย์เฉพาะทาง',
    dd: 'ความรับผิดส่วนแรก ต่อการเข้าพักรักษาตัวเป็นผู้ป่วยในครั้งใดครั้งหนึ่ง',
    dental: 'ค่าบริการทางทันตกรรม',
    dental_es: 'การตรวจช่องปากหรือการขูดหินปูน',
    dental_ex: 'การอุดฟัน การถอนฟัน การผ่าฟันคุด และการรักษารากฟัน',
    dental_x: 'การตรวจวินิจฉัยช่องปากโดยการเอ๊กเรย์และทดสอบในห้องทดลองปฏิบัติการ',
    doct_fee: 'ค่าแพทย์ตรวจรักษาในโรงพยาบาล',
    er_oversea: 'การช่วยเหลือทางการแพทย์ฉุกเฉินในต่างประเทศ',
    fwp: 'ค่าปรึกษาแพทย์ต่อเนื่องในฐานะผู้ป่วยนอกหลังการรักษาตัวในโรงพยาบาล',
    ghe: 'ค่ารักษาพยาบาลอื่น ๆ',
    hb: '"ค่าชดเชยรายวัน กรณีเข้ารับการรักษาตัวในโรงพยาบาล ในฐานะผู้ป่วยใน แต่มิได้ใช้สิทธิเรียกร้องตามสัญญาเพิ่มเติมการประกันภัยสุขภาพกลุ่ม',
    hc: 'ค่าตรวจสุขภาพ',
    hiv: 'ค่ารักษาเอชไอวีและโรคเอดส์',
    hnp: 'การดูแลแบบประคับประคองระยะสุดท้าย',
    hormone: 'ค่ารักษาด้วยฮอร์โมนทดแทน',
    hr: 'ค่ารักษาทางโสตประสาท และการได้ยิน',
    icu: 'ค่าห้องไอซียู',
    lab: 'ค่าตรวจทางห้องทดลองปฏิบัติการ',
    major_er: 'ค่ารักษาพยาบาลฉุกเฉินเนื่องจากอุบัติเหตุ ที่มีค่าใช้จ่ายสูง',
    major_fwp: 'ค่ารักษาพยาบาลต่อเนื่องจากการนอน รพ. ค่าใช้จ่ายสูง',
    major_med: 'ค่ารักษาพยาบาลที่มีค่าใช้จ่ายสูง',
    major_rb: 'ค่าห้องค่าอาหารและการพยาบาลมีค่าใช้จ่ายสูง',
    major_sur: 'ค่าหัถการในห้องผ่าตัดใหญ่ที่มีค่าใช้จ่ายสูง',
    med: 'ค่ายา',
    med_home: 'ค่ายากลับบ้าน',
    med_hosp: 'ค่ายา ค่าสารอาหารทางหลอดเลือดในโรงพยาบาล',
    med_oper: 'ค่ายา ค่าสารอาหารทางหลอดเลือดในห้องผ่าตัด',
    mt_c: 'ผ่าตัดคลอด',
    mt_m: 'ขูดมดลูก',
    mt_nb: 'คลอดปกติ',
    mt_oper: 'ค่าเวชภัณฑ์ ในห้องผ่าตัด',
    mt1: 'ค่าเวชภัณฑ์ 1',
    mt2: 'ค่าเวชภัณฑ์ 2',
    mt3: 'ค่าเวชภัณฑ์ 3',
    nba: 'หออภิบาลทารกแรกเกิด',
    ns: 'ค่าบริการพยาบาล',
    oct: 'ค่ารักษามะเร็งแบบผู้ป่วยนอก',
    okd: 'ค่าล้างไตแบบผู้ป่วยนอก',
    opd: 'ค่ารักษาพยาบาลในฐานะผู้ป่วยนอก แบบจำกัดผลประโยชน์ต่อปี',
    opd_v: 'ค่ารักษาพยาบาลในฐานะผู้ป่วยนอก แบบจำกัดผลประโยชน์ต่อครั้ง',
    oper: 'ค่าห้องผ่าตัดและอุปกรณ์',
    ot: 'ค่าอุปกรณ์เพื่อช่วยในการมองเห็น ',
    other: 'ค่าบริการอื่น ๆ',
    ov: 'ส่วนเกินวงเงินผลประโยชน์ผู้ป่วยนอก',
    pa: 'ค่ารักษาพยาบาลเนื่องจากอุบัติเหตุ',
    parent_rb: 'ค่าห้องพักสำหรับผู้ปกครอง ',
    pct: 'ค่ารักษาด้านจิตเวช',
    pnc: 'ค่ารักษาสำหรับการตั้งครรภ์และคลอดบุตร',
    ppnc: 'ภาวะแทรกซ้อนก่อนและหลังคลอดบุตร',
    pre_ad: 'ค่าปรึกษาแพทย์ในฐานะผู้ป่วยนอกก่อนเข้ารักษาพยาบาลในฐานะผู้ป่วยใน',
    psp: 'ค่ากายภาพบำบัด',
    px: 'ขยายความคุ้มครองโรคที่เป็นมาก่อนประกัน',
    r_b: 'ค่าห้อง และค่าอาหารต่อวัน ',
    sn: 'ค่าบริการพยาบาลพิเศษ',
    ss_sa: 'ค่าแพทย์ผ่าตัดและหัตถการ - แบบจ่ายตามจริง',
    ss_ss: 'ค่าแพทย์ผ่าตัดและหัตถการ  - แบบอิงตารางค่าผ่าตัด',
    tcm: 'ค่ารักษาการแพทย์แผนจีน',
    trc: 'ค่าทำหมัน',
    vc: 'ค่าวัคซีน',
  },
  //
  THB: 'บาท',

  errorPage: {
    title404: 'ไม่พบหน้าที่คุณกำลังค้นหา',
    title500: 'ขออภัย เซิร์ฟเวอร์ภายในของเราเกิดข้อผิดพลาด',
    desc500:
      'ขณะนี้เซิร์ฟเวอร์ภายในของเราเจอข้อผิดพลาดชั่วคราว ไม่สามารถดำเนินการตามคำขอของคุณได้ กรุณาลองใหม่อีกครั้งหรือกลับไปหน้าแรก',
    title503: 'ไม่สามารถให้บริการได้ในขณะนี้',
    desc503: 'กรุณาลองใหม่อีกครั้ง',
    titleNoInternet: 'การเชื่อมต่ออินเทอร์เน็ตผิดพลาด',
    descNoInternet: 'โปรดตรวจสอบว่า Wi-Fi หรือข้อมูลมือถือเปิดอยู่\nจากนั้นลองอีกครั้ง',
    ok: 'ตกลง',
    backToHome: 'กลับสู่หน้าหลัก',
    tryAgain: 'ลองอีกครั้ง',
  },

  // Personal Information
  profile: {
    MyAccount: 'บัญชีผู้ใช้งาน',
    PersonalInformation: 'ข้อมูลส่วนบุคคล',
    Name: 'ชื่อ',
    Surname: 'นามสกุล',
    Dob: 'วันเกิด',
    Contact: 'ช่องทางติดต่อ',
    MobilePhone: 'เบอร์โทร',
    Email: 'อีเมล',
    AccountInformation: 'ข้อมูลบัญชีธนาคาร',
    BankAccount: 'ชื่อธนาคาร',
    AccountNumber: 'เลขที่บัญชี',
    Tos: 'ข้อตกลงการให้บริการ',
    Tac: 'ข้อกำหนดและเงื่อนไข',
    PrivacyPolicy: 'นโยบายความปลอดภัยของข้อมูล',
    Back: 'ย้อนกลับ',
  },

  // Policy & Coverage page
  'Group Health Package': 'ประกันชีวิตและสุขภาพกลุ่ม',
  'Policy Summary': 'ข้อมูลกรมธรรม์',
  'Policy Status': 'สถานะกรมธรรม์',
  'Policy Number': 'หมายเลขกรมธรรม์',
  'Policy Name': 'ชื่อกรมธรรม์',
  'Member Number': 'หมายเลขสมาชิก',
  'Member Name': 'ชื่อสมาชิกในกรมธรรม์',
  'Dependent Number': 'หมายเลขอ้างอิง',
  'Plan Number': 'หมายเลขแผน',
  'Start Date Coverage': 'วันที่กรมธรรม์มีผลบังคับ',
  'End Date Coverage': 'วันครบกำหนดสัญญา',
  'You are currently viewing': 'คุณกำลังดูรายการของคุณ',
  'BACK TO TOP': 'กลับสู่ \n ด้านบน',

  // General
  'Claim Inquiry': 'ประวัติการเรียกร้องสินไหม',

  // DOWNLOAD DOCUMENTS
  selectDocument: 'เลือกเอกสาร',
  downloadDocuments: 'ดาวน์โหลดเอกสาร',
  claimForm: 'ใบเรียกร้องค่าสินไหมทดแทน',
  employeeManual: 'คู่มือสวัสดิการพนักงานประกันกลุ่ม',
  otherForm: 'แบบฟอร์มและเอกสารต่างๆ',

  // Insurance Group
  'group-health-package': 'ประกันชีวิตและสุขภาพกลุ่ม',
  'group-pa-package': 'ประกันอุบัติเหตุกลุ่ม',
  'group-credit-life': 'ประกันกลุ่มแบบคุ้มครองสินเชื่อ',

  // Insurance Services
  insuranceServices: 'บริการด้านความคุ้มครอง',

  // layout
  tel: 'โทร.',
  downloadEmma: 'ดาวน์โหลด Emma by AXA',
  followUs: 'ติดตามเรา',
  copyRight: `ลิขสิทธิ์ถูกต้อง © ${new Date().getFullYear()} บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)`,
  backButton: 'ย้อนกลับ',

  // Reminder
  policyOwner: 'เจ้าของกรมธรรม์',

  claimInquiryNotFoundTitle: 'ไม่พบประวัติการทำรายการ',
  claimInquiryNotFoundDesc: 'ไม่พบรายการเรียกร้องสินไหมในขณะนี้',
};
